<template>
  <apexchart
    :height="250"
    type="line"
    :series="
      [{
        name: `${graphData.field_name}`,
        data: [...graphData.series]
      }]"
    :options="{
      chart: {
        id: `vuechart-${graph.id}`,
        zoom: {
          enabled: false
        },
        toolbar: {
          show: true,
          export: {
            csv: {
              filename: `${graph.name}`
            },
            svg: {
              filename: `${graph.name}`
            },
            png: {
              filename: `${graph.name}`
            }
          }
        }
      },
      colors: [chartColor],
      xaxis: {
        categories: [...graphData.labels]
      }
    }"
    ref="apexChart"
  ></apexchart>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'Line-Chart',
  props: ['graph', 'graphData'],
  components: {
    apexchart: VueApexCharts
  },
  data ()  {
    return {
      chartColor: JSON.parse(localStorage.getItem('localization')).secondary_color
    }
  }
}
</script>
